import { Navigate, RouteObject } from 'react-router-dom';

import { Login } from './Login';
import { OIDCCallback } from './OIDCCallback';

export const loginRoute: RouteObject = {
  path: '',
  children: [
    { index: true, element: <Navigate to="login" replace /> },
    { path: 'login', element: <Login /> },
    { path: 'login/oidc/callback', element: <OIDCCallback /> },
  ],
};
